import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Customform from "./addForm.js";
import "../../../styles/Form.css";
import AWS from "../../../utils/awsConfig.js";
import { MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "Title", name: "title", placeholder: "Enter Title", required: true },
  {
    label: "Description",
    name: "description",
    placeholder: "Enter brief description",
    required: true,
  },
  {
    label: "Is Featured",
    name: "isFeatured",
    type: "select", // Important for single select
    options: [
      { label: "True", value: true },
      { label: "False", value: false },
    ],
  },
  
  
 
  {
    label: "Image",
    name: "image",
    placeholder: "Choose Images",
    type: "file",
    multiple: true,
  },
  
 
];

const AddBlob = () => {
  const navigate = useNavigate();
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};
  const handleSubmit = async (formData) => {
    try {
      if (imageFiles) {
        const uploadedImageUrl = await handleImageUpload(imageFiles);
        formData.image = uploadedImageUrl;  // Single Image Only
      }
  
      const response = await axios.post(`${API_URL}/offers/createOffer`, formData);
      
      if (response.status === 200 || response.status === 201) {
        toast.success("Offer added successfully");
        navigate("/offers");
      } else {
        throw new Error("Unexpected server response");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error adding offer");
    }
  };
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreviews(URL.createObjectURL(file)); // For Preview
      setImageFiles(file); // For Upload
    }
  };
  
  
  


  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Blog
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/offers")}
        >
          &times;
        </button>
      </div>
      <Customform
       mode={MODE.ADD}
        onSubmit={handleSubmit}
        fields={fields}
        imagePreview={imagePreviews}
        handleCustomerImageChange={handleImageChange}
      />
    </div>
  );
};

export default AddBlob;
